import { Coordinate } from "@fairfleet/geotab";

/**
 * Reads a usable {@link Coordinate} out of a value Geotab typed as `unknown`.
 *
 * `ChargeEvent.location` and `FuelEvent.location` are both typed that way and both default to
 * `0,0` when nothing was recorded. Null Island is off the coast of Ghana, so passing that
 * through would put a charging stop or a fill-up in the Gulf of Guinea, and a reverse geocode
 * would dutifully name a place. A missing position has to stay missing.
 *
 * @param value - The location as it came off the entity.
 * @returns The coordinate, or `null` when there is no usable position.
 */
export function toCoordinate(value: unknown): Coordinate | null {
  if (!value || typeof value !== "object") {
    return null;
  }

  const { x, y } = value as { x?: unknown; y?: unknown };
  if (typeof x !== "number" || typeof y !== "number") {
    return null;
  }
  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    return null;
  }
  if (x === 0 && y === 0) {
    return null;
  }

  return { x, y };
}
